import { connect } from 'react-redux';
import LoginComponent from '../../components/login/LoginComponent';

const mapStateToProps = state => ({
    isLogged: state.user.isLogged,
});

export default connect(mapStateToProps, null)(LoginComponent);
